<template>
  <div>
    <div>
      <p class="sheet-title">{{ productDescriptionTitle }}</p>
      <content-show-more v-model="shouldAllShow" class-name="ma-0">
        <div id="productIntro__sheetContent" :class="[{ allContent: shouldAllShow }, 'sheet-content']">
          <ContentData v-for="(data, idx) in introListUiData" :key="idx" v-bind="data" @image-click="openImgModal" />
        </div>
      </content-show-more>

      <image-detail-modal ref="imageDetailModal" :images="[clickedImage]" :should-hide-pagination-number="true" :should-encode-image-path="false" />
    </div>
  </div>
</template>

<script>
import ImageDetailModal from '@/components/dialog/image-detail-modal.vue'
import ContentShowMore from '@/components/ContentShowMore.vue'
import ContentData from '@/components/ContentData.vue'
import { ProductDetailHtmlType } from '@/view-models/product'

export default defineComponent({
  name: 'ProductIntro',
  components: {
    ImageDetailModal,
    ContentShowMore,
    ContentData,
  },
  props: {
    introList: { type: Array, default: () => [] },
  },
  setup() {
    const { productDescriptionTitle } = usePlatformProductContext()

    return {
      productDescriptionTitle,
    }
  },
  data() {
    return {
      clickedImage: '',
      shouldAllShow: false,
      ProductDetailHtmlType,
    }
  },
  computed: {
    introListUiData() {
      return this.introList.map(item => ({
        type: item.type,
        meta: item.meta,
        list: item.attr?.list || [],
        mediaWidth: item.attr?.width || 0,
        mediaHeight: item.attr?.height || 0,
      }))
    },
  },
  methods: {
    openImgModal(imgUrl) {
      this.clickedImage = imgUrl
      this.$refs.imageDetailModal.showModal()
    },
  },
})
</script>

<style lang="scss" scoped>
.sheet-content {
  position: relative;
  max-height: 400px;
  overflow: hidden;
  &#productIntro__sheetContent {
    margin-bottom: 0px;
    :deep(p) {
      margin-bottom: 0px;
    }
  }
  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 120px;
    background: linear-gradient(rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 70%);
  }

  &.allContent {
    max-height: none;
    &#productIntro__sheetContent {
      margin-bottom: 20px;
    }
    &::after {
      content: none;
    }
  }

  @include xxs {
    max-height: 340px;
    &#productIntro__sheetContent {
      margin-bottom: 0px;
    }
    &.allContent {
      &#productIntro__sheetContent {
        margin-bottom: 16px;
      }
    }
  }
}
</style>
